import ActionTypes from '../../../constants/ActionTypes';
import { PushDeviceClickFromListToAnalyticsActionPayload, PushDeviceListToAnalyticsActionPayload } from './types';
import { PaymentOptionsType } from '../../../constants/PaymentOptions';
import {
  GA4EcommerceItem,
  GA4Item,
  GA4MobEventType,
  GA4PPRContentData,
  GA4PromotionDetails,
  GA4TopupAnalytics,
} from './ga4/types';

export const pushDeviceListToAnalyticsAction = (payload: PushDeviceListToAnalyticsActionPayload) => {
  return {
    type: ActionTypes.ANALYTICS.DEVICE_IMPRESSIONS,
    payload,
  };
};

export const pushDeviceClickFromListToAnalyticsAction = (payload: PushDeviceClickFromListToAnalyticsActionPayload) => {
  return {
    type: ActionTypes.ANALYTICS.DEVICE_CLICK_FROM_LIST,
    payload,
  };
};

export const pushDeviceOverviewToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.DEVICE_OVERVIEW,
  };
};

export const pushDevicePlanChangeToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.DEVICE_OVERVIEW_PLAN_CHANGE,
  };
};

export const pushAddToBasketToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.ADD_TO_BASKET,
  };
};

export const pushEmptyCartToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.EMPTY_CART,
  };
};

export const pushCheckoutStepToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.CHECKOUT_STEP,
  };
};

export const pushSubmitOrderToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.SUBMIT_ORDER,
  };
};

export const pushCancelOrderToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.CANCEL_ORDER,
  };
};

export const pushOrderCanceledToAnalytics = () => {
  return {
    type: ActionTypes.ANALYTICS.ORDER_CANCELED,
  };
};

export const pushAccessoryGoToCheckoutToAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.ACESSORY_GO_TO_CHECKOUT,
  };
};

export const viewCartAnalyticsAction = (orderType: string, stepName: string, previousSteps: any[]) => {
  return {
    type: ActionTypes.ANALYTICS.VIEW_CART,
    payload: {
      orderType,
      stepName,
      previousSteps,
    },
  };
};

export const mobViewCartAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.JUST_VIEW_CART,
  };
};

export const mobViewCampaignCartAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.CAMPAIGN_VIEW_CART
  };
};

export const mobViewCampaignCartStepAnalyticsAction = (eventName: string) => {
  return {
    type: ActionTypes.ANALYTICS.P2PDJ_STEP,
    payload: eventName
  };
};


export const mobViewCampaignCartPurchaseAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.P2PDJ_PURCHASE
  };
};

export const selectPaymentOptionAnalyticsAction = (paymentOption: PaymentOptionsType) => {
  return {
    type: ActionTypes.ANALYTICS.SELECT_PAYMENT_OPTION,
    payload: {
      paymentOption,
    },
  };
};

export const addShippingTierAnalyticsAction = (shippingTier: string) => {
  return {
    type: ActionTypes.ANALYTICS.ADD_SHIPPING_INFO,
    payload: {
      shippingTier,
    },
  };
};

export const nextCheckoutStepAnalyticsAction = (orderType: string, stepName: string, previousSteps: any[]) => {
  return {
    type: ActionTypes.ANALYTICS.NEXT_CHECKOUT_STEP,
    payload: {
      orderType,
      stepName,
      previousSteps,
    },
  };
};

export const purchaseAnalyticsAction = (orderType: string, stepName: string, previousSteps: any[]) => {
  return {
    type: ActionTypes.ANALYTICS.PURCHASE,
    payload: {
      orderType,
      stepName,
      previousSteps,
    },
  };
};

export const refundAnalyticsAction = () => {
  return {
    type: ActionTypes.ANALYTICS.REFUND,
  };
};

export const viewPromotionAnalyticsAction = (details: GA4PromotionDetails, items: GA4Item[]) => {
  return {
    type: ActionTypes.ANALYTICS.VIEW_PROMOTION,
    payload: {
      details,
      items,
    },
  };
};

export const selectPromotionAnalyticsAction = (details: GA4PromotionDetails, item: GA4Item) => {
  return {
    type: ActionTypes.ANALYTICS.SELECT_PROMOTION,
    payload: {
      details,
      item,
    },
  };
};

export const choosePackageAnalyticsAction = (data: Partial<GA4EcommerceItem>) => {
  return {
    type: ActionTypes.ANALYTICS.CHOOSE_PACKAGE,
    payload: data,
  };
};

export const submitCampaignChoice = (data: Partial<GA4EcommerceItem>, eventName: GA4MobEventType) => {
  return {
    type: ActionTypes.ANALYTICS.SUBMIT_CAMPAIGN_CHOICE,
    payload: {
      data,
      eventName,
    },
  };
};

export const campaignConfirmationPageAnalytics = (eventName: GA4MobEventType) => {
  return {
    type: ActionTypes.ANALYTICS.CAMPAIGN_CONFIRMATION,
    payload: eventName,
  };
};

export const selectInsuranceAnalyticsAction = (items: GA4Item[]) => {
  return {
    type: ActionTypes.ANALYTICS.SELECT_INSURANCE,
    payload: {
      items,
    },
  };
};

export const topupAnalyticsStepAction = (data: GA4TopupAnalytics) => {
  return {
    type: ActionTypes.ANALYTICS.TOPUP_STEP,
    payload: {
      data,
    },
  };
};

export const pprInteractionAnalyticsAction = (eventName: string, contentData: GA4PPRContentData) => {
  return {
    type: ActionTypes.ANALYTICS.PPR_INTERACTION,
    payload: {
      eventName,
      contentData,
    },
  };
};
